







import Component, { mixins } from "vue-class-component";
import { CallStatus, isCallMessageDetails } from "@scrile/api-provider/dist/api/CallsProvider";
import { $t } from "@/lib/i18nHelpers";
import MessagePreviewMixin from "../mixins/MessagePreviewMixin";

@Component({ name: "MessagePreview" })
export default class MessagePreview extends mixins(MessagePreviewMixin) {
  public get opponentMessage() {
    if (isCallMessageDetails(this.message.details)) {
      return this.message.details.callerId !== Number(this.authUserId);
    }
    return false;
  }

  public get text(): string {
    if (isCallMessageDetails(this.message.details)) {
      const status = this.message.details.status;
      if (status === CallStatus.ENDED) {
        return this.opponentMessage ? $t("{0} call", [$t("Incoming")]) : $t("{0} call", [$t("Outgoing")]);
      }
      if (this.opponentMessage) return $t("{0} call", [$t("Missed")]);
      if (status === CallStatus.CANCELLED) return $t("{0} call", [$t("Canceled")]);
      if (status === CallStatus.DECLINED) return $t("{0} call", [$t("Declined")]);
    }
    return "";
  }
}
